<script setup>
const ServicesDesktopContent = defineAsyncComponent(() => import('~/components/molecules/ServicesDesktopContent.vue'));

definePageMeta({
  layout: "services-layout",
});
</script>

<template>
    <ServicesDesktopContent />
</template>